import { render, staticRenderFns } from "./GlCpuHistory.vue?vue&type=template&id=6898bb58&scoped=true"
import script from "./GlCpuHistory.vue?vue&type=script&lang=js"
export * from "./GlCpuHistory.vue?vue&type=script&lang=js"
import style0 from "./GlCpuHistory.vue?vue&type=style&index=0&id=6898bb58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6898bb58",
  null
  
)

export default component.exports